import axios from "axios";

export const AxiosProvider = axios.create();
